<template>
	<div>
		<div class="box">
			<div>
				<v-container class="card-wrapper" grid-list-lg>
					<v-layout class="card-inner-wrapper" row wrap>
						<Card
							v-for="routesObject in routes"
							:card_element="routesObject"
							:key="routesObject.name"
							class="card-item"
						/>
					</v-layout>
				</v-container>
			</div>
		</div>
	</div>
</template>

<script>
import Card from '@/components/cards/Card';
import _routes from '@/config/router_array/routes.js';

export default {
	name: 'Home',
	components: {
		Card,
	},
	data: () => {
		return {};
	},
	computed: {
		routes() {
			return _routes.filter((el) => {
				return el.isDashboard;
			});
		},
	},
};
</script>

<style lang="scss" scoped>
body {
	display: flex;
	height: 95vh;
	padding: 0;
	margin: 0;
	justify-content: center;
	align-items: center;
}

.card-wrapper {
	background-color: #f9f9f9;
	position: relative;
	max-width: 100%;
	.card-inner-wrapper {
		z-index: 3;
		position: relative;
		margin: -8px auto !important;
		@media only screen and (min-width: 960px) {
			max-width: 900px;
		}
	}
}

.card-item {
	width: 50%;
}
</style>
